import React, { Component } from 'react'
import { PlaidCard } from './bankAccountCards/plaidCard'
import { MicroCard } from './bankAccountCards/microCard'
import { DefaultCard } from './bankAccountCards/defaultCard'
import { User } from '../../core/types'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  user: User
  deleteAccount: Callback
}

export class UserBankAccounts extends Component<Props> {
  static displayName = 'UserBankAccounts'

  render() {
    const {
      deleteAccount,
      user: { bankAccounts },
    } = this.props

    if (!bankAccounts) {
      return null
    }

    const currentAccount = bankAccounts[0]

    if (currentAccount === undefined) {
      return <DefaultCard />
    } else if (
      currentAccount.verificationMethod === 'PLAID' ||
      currentAccount.verificationMethod === 'PLAID_LINK'
    ) {
      return <PlaidCard {...currentAccount} deleteAccount={deleteAccount} />
    } else if (currentAccount.verificationMethod === 'MICRODEPOSIT') {
      return <MicroCard {...currentAccount} deleteAccount={deleteAccount} />
    } else {
      return <DefaultCard />
    }
  }
}

export default UserBankAccounts
